import { type CancelToken } from 'axios';
import { apiPost } from '~/_shared/utils/api/api.helpers';

export const LOCATION_COUNT_ID = 'location_count';
/**
 * Metric identifier for BE API.
 * Can be RESPONSE_LOCATION_COUNT_ID ('location_count'), a demographic category, or a column id (column_X).
 */
export type OptimizedTerritoriesMetricServerId = typeof LOCATION_COUNT_ID | string;

export type ValidateWMSTerritoryConstraintsItem = {
  column_id: string | null;
  column_value: string | null;
  max: number;
  metric: OptimizedTerritoriesMetricServerId;
  min: number;
};

export type ValidateWMSTerritoryConstraintsRequest = {
  boundary_group_id: number;
  map_id: number;
  spreadsheet_id: number;
  constraints: ValidateWMSTerritoryConstraintsItem[];
  dataset_states?: ReadonlyArray<string>;
  dataset_zip_codes?: ReadonlyArray<string>;
};

export type ValidateTerritoryConstraintResultItem = {
  column_id?: string;
  column_value?: string;
  limits: {
    lowestMax: number | null;
    highestMin: number | null;
    min: number;
    max: number;
  };
  value: {
    min: number;
    max: number;
  };
  errors: string[];
  isValid: boolean;
};

export type ValidateWMSTerritoryConstraintResultItem = ValidateTerritoryConstraintResultItem & {
  metric: OptimizedTerritoriesMetricServerId;
};

type ValidateWMSTerritoryConstraintsResponse = {
  results: ValidateWMSTerritoryConstraintResultItem[];
};

export const validateWMSTerritoryConstraints = (
  clientId: number, params: ValidateWMSTerritoryConstraintsRequest, cancelToken?: CancelToken
): Promise<ValidateWMSTerritoryConstraintsResponse> => {
  const requestUrl = `/api/clients/${clientId}/optimized-territories/constraints`;

  return apiPost(requestUrl, params, {
    cancelToken,
  });
};
